
import ShieldTick from "../../../assets/outline/ShieldTick.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ShieldTickIcon({ className, dataTestid = "ShieldTickIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ShieldTick data-testid={dataTestid} className={classes} {...rest} />
  );
}
